import {
  getAction,
  deleteAction,
  putAction,
  postAction
} from '@/api/mobileManage'

import { baseURL } from '@/utils/network'

// 新增一级地块
const addManor = (params) => postAction('/api/manor', params)
// 获取一级地块
const getManor = (params) => getAction('/api/manor', params)
// 修改一级地块
const updateManor = (params) => putAction('/api/manor', params)
// 删除一级地块 
const deleteManor = (params) => deleteAction('/api/manor', params)

// 首页_地块信息
const getManorDetails = (params) => getAction('/manor/details/' + params)

// 四级地块
const getManorFourArea = (params) => getAction('/manor/fourArea/' + params)

// 首页_土地认购
const getSubscription = (params) => getAction('/manor/subscription', params)

// 土地认购_类别页
const getSubscriptionType = (params) => getAction('/manor/subscriptionType', params)

// vr详情
const showVr = (params) => getAction('/manor/showVr/' + params)

export default {
  getManorDetails,
  getManorFourArea,
  getSubscription,
  getSubscriptionType,
  showVr,
}


// WEBPACK FOOTER //
// ./src/api/mobileApi.js